export const MODE_PAIEMENT = [
    {id: 0, description: "Comptant"}, 
    {id: 1, description: "Chèque"}, 
    {id: 2, description: "Autre"}, 
    {id: 3, description: "Interac"}, 
    {id: 4, description: "Visa"}, 
    {id: 5, description: "Mastercard"}, 
    {id: 6, description: "American Express"}, 
    {id: 7, description: "Dépôt direct"}, 
    {id: 8, description: "Ajustement cent"}, 
    {id: 9, description: "Certificat-Cadeau"}, 
    {id: 10, description: "Discover"}, 
    {id: 11, description: "Paiement refusé"}, 
    {id: 12, description: "Transfert de paiement"}
  ]